import React from 'react';

import { QUERY_ROOT_ID, useCompleteFragment } from '@eluve/apollo-client';
import { NewButton, VStack } from '@eluve/components';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@eluve/components';

import { SiteBannerItem } from './SiteBannerItem';
import { siteBannersPublicDataFragment } from './operations';

type Props = {
  open: boolean;
  toggleOpen: () => void;
};

export const SystemStatusDialog: React.FC<Props> = ({ open, toggleOpen }) => {
  const data = useCompleteFragment({
    fragment: siteBannersPublicDataFragment,
    key: { id: QUERY_ROOT_ID },
    strict: false,
  });

  return (
    <Dialog open={open} onOpenChange={toggleOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="font-normal tracking-normal text-text-secondary">
            System Status
          </DialogTitle>
        </DialogHeader>

        {data?.siteBanners.length ? (
          <VStack gap={2}>
            {data?.siteBanners.map((item) => (
              <SiteBannerItem
                key={`message-center-banner-item-${item.id}`}
                bannerType={item.bannerType}
                message={item.message}
                title={item.title}
              />
            ))}
          </VStack>
        ) : (
          <>There are no active system alerts or notifications at this time.</>
        )}

        <DialogFooter>
          <NewButton type="subtle" text="Dismiss" onClick={toggleOpen} />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
